import { CalendarClock, Workflow, Zap } from 'lucide-react';

/**
 * The three kinds of automation, keyed by the segment they use in `/automations/:kind/:id`.
 * `threadType` is the conversation type Pieve builds a new one in, so the assistant starts in the right mode.
 */
const AUTOMATION_KINDS = Object.freeze({
  schedules: { kind: 'schedules', icon: CalendarClock, singular: 'Schedule', plural: 'Schedules', threadType: 'schedule', startsLabel: 'On a schedule' },
  triggers: { kind: 'triggers', icon: Zap, singular: 'Trigger', plural: 'Triggers', threadType: 'trigger', startsLabel: 'When something happens in an app' },
  workflows: { kind: 'workflows', icon: Workflow, singular: 'Workflow', plural: 'Workflows', threadType: 'workflow_requirements', startsLabel: 'As a workflow of several steps' }
});

export default AUTOMATION_KINDS;
